import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  createThis2j2avj17cvnv2 as createThis,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  numberToDouble210hrknaofnhf as numberToDouble,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  umod1d8wj61c81r0q as umod,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  interpolate2g7wzskc23f1q as interpolate,
  interpolate35pbs3ac913y4 as interpolate_0,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.y27_1 = Anchor2D.j28(0.0, 0.0);
    this.z27_1 = Anchor2D.j28(0.5, 0.0);
    this.a28_1 = Anchor2D.j28(1.0, 0.0);
    this.b28_1 = Anchor2D.j28(0.0, 0.5);
    this.c28_1 = Anchor2D.j28(0.5, 0.5);
    this.d28_1 = Anchor2D.j28(1.0, 0.5);
    this.e28_1 = Anchor2D.j28(0.0, 1.0);
    this.f28_1 = Anchor2D.j28(0.5, 1.0);
    this.g28_1 = Anchor2D.j28(1.0, 1.0);
  }
  k28() {
    return this.c28_1;
  }
}
class Anchor2D {
  static l28(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.h28_1 = sx;
    $this.i28_1 = sy;
    return $this;
  }
  static j28(sx, sy) {
    Companion_getInstance();
    return this.l28(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.h28_1 + ', sy=' + this.i28_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.h28_1);
    result = imul(result, 31) + getNumberHashCode(this.i28_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.h28_1, tmp0_other_with_cast.h28_1))
      return false;
    if (!equals(this.i28_1, tmp0_other_with_cast.i28_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio = toRatio(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.n28_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_0 = toRatio(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.o28_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_1 = toRatio(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.p28_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_2 = toRatio(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.q28_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_3 = toRatio(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.r28_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_4 = toRatio(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.s28_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.m28_1 = radians;
  }
  t28(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.m28_1, other, epsilon);
  }
  hy(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  u28(other) {
    return Angle__compareTo_impl_a0hfds(this.m28_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.m28_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.m28_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.m28_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.s29_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().w29());
  }
  x29() {
    return this.s29_1;
  }
  y29(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().b2a(Companion_getInstance_17().z29(p1, p2, p3, p4), Companion_getInstance_17().a2a(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.k2a_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.k2a_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.k2a_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.k2a_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.l2a_1 = center;
    this.m2a_1 = radius;
  }
  n2a() {
    return this.m2a_1 * this.m2a_1;
  }
  o2a(p) {
    return Companion_getInstance_17().p2a(p, this.l2a_1);
  }
  q2a(p) {
    return this.o2a(p) - this.n2a();
  }
  r2a(p) {
    return this.o2a(p) + this.n2a();
  }
  toString() {
    return 'Circle(center=' + this.l2a_1.toString() + ', radius=' + this.m2a_1 + ')';
  }
  hashCode() {
    var result = this.l2a_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.m2a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.l2a_1.equals(tmp0_other_with_cast.l2a_1))
      return false;
    if (!equals(this.m2a_1, tmp0_other_with_cast.m2a_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.t2a_1 = $index;
    this.u2a_1 = this$0;
    this.s2a_1 = $index;
  }
  b1() {
    return this.s2a_1 >= this.u2a_1.y2a_1;
  }
  c1() {
    var _unary__edvuaz = this.s2a_1;
    this.s2a_1 = _unary__edvuaz + 1 | 0;
    return this.u2a_1.d1(_unary__edvuaz);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.v2a_1 = list;
    this.w2a_1 = fromIndex;
    this.x2a_1 = toIndex;
    this.y2a_1 = this.x2a_1 - this.w2a_1 | 0;
  }
  e1() {
    return this.y2a_1;
  }
  d1(index) {
    return this.v2a_1.d1(index + this.w2a_1 | 0);
  }
  g1() {
    return this.y2a_1 === 0;
  }
  a1() {
    return this.u2();
  }
  u2() {
    return this.v2(0);
  }
  v2(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  w2(fromIndex, toIndex) {
    return new Sublist(this.v2a_1, this.w2a_1 + fromIndex | 0, this.w2a_1 + toIndex | 0);
  }
  z2a(elements) {
    return Companion_instance_3.a2b(this, elements);
  }
  t2(elements) {
    return this.z2a(elements);
  }
}
class Companion_3 {
  a2b(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.math.geom.Companion.containsAllSet.<anonymous>' call
        if (!s.s2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
}
class IDoubleVectorList {}
function isNotEmpty() {
  return !(this.e1() === 0);
}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.e1() === other.e1()))
    return false;
  if (!(this.h2b() === other.h2b()))
    return false;
  var inductionVariable = 0;
  var last = this.h2b();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.f2b(n, dim), other.f2b(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.d2b(this.b2b(index), this.c2b(index));
}
function containsAll(elements) {
  return Companion_instance_3.a2b(this, elements);
}
function iterator() {
  return this.u2();
}
function listIterator() {
  return this.v2(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.e1())).v2(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.i2b_1 = Line2D.m2b(Companion_getInstance_17().z28_1, Companion_getInstance_17().z28_1);
    this.j2b_1 = Line2D.m2b(Companion_getInstance_17().a29_1, Companion_getInstance_17().a29_1);
  }
}
class Line2D {
  static m2b(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.k2b_1 = a;
    $this.l2b_1 = b;
    return $this;
  }
  static n2b() {
    Companion_getInstance_4();
    return this.m2b(Vector2D.o2b(), Vector2D.o2b());
  }
  static p2b(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.m2b(Vector2D.q2b(x0, y0), Vector2D.q2b(x1, y1));
  }
  r2b() {
    return this.k2b_1.x28_1;
  }
  s2b() {
    return this.k2b_1.y28_1;
  }
  t2b() {
    return this.l2b_1.x28_1;
  }
  u2b() {
    return this.l2b_1.y28_1;
  }
  toString() {
    return 'Line(' + this.k2b_1.toString() + ', ' + this.l2b_1.toString() + ')';
  }
  hashCode() {
    var result = this.k2b_1.hashCode();
    result = imul(result, 31) + this.l2b_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.k2b_1.equals(tmp0_other_with_cast.k2b_1))
      return false;
    if (!this.l2b_1.equals(tmp0_other_with_cast.l2b_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.v2b_1 = MarginInt.a2c(0, 0, 0, 0);
  }
}
class MarginInt {
  static a2c(top, right, bottom, left) {
    Companion_getInstance_5();
    var $this = createThis(this);
    $this.w2b_1 = top;
    $this.x2b_1 = right;
    $this.y2b_1 = bottom;
    $this.z2b_1 = left;
    return $this;
  }
  static b2c(margin) {
    Companion_getInstance_5();
    return this.a2c(margin, margin, margin, margin);
  }
  c2c() {
    return !(this.w2b_1 === 0) || !(this.z2b_1 === 0) || !(this.x2b_1 === 0) || !(this.y2b_1 === 0);
  }
  d2c() {
    return this.z2b_1 + this.x2b_1 | 0;
  }
  e2c() {
    return this.w2b_1 + this.y2b_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.w2b_1 + ', right=' + this.x2b_1 + ', bottom=' + this.y2b_1 + ', left=' + this.z2b_1 + ')';
  }
  hashCode() {
    var result = this.w2b_1;
    result = imul(result, 31) + this.x2b_1 | 0;
    result = imul(result, 31) + this.y2b_1 | 0;
    result = imul(result, 31) + this.z2b_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.w2b_1 === tmp0_other_with_cast.w2b_1))
      return false;
    if (!(this.x2b_1 === tmp0_other_with_cast.x2b_1))
      return false;
    if (!(this.y2b_1 === tmp0_other_with_cast.y2b_1))
      return false;
    if (!(this.z2b_1 === tmp0_other_with_cast.z2b_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.f2c_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.g2c_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.h2c_1 = this.g2c_1;
  }
  i2c() {
    return this.f2c_1;
  }
  j2c(a, b, epsilon) {
    return isAlmostEquals(a.o2c_1, b.o2c_1, epsilon) && isAlmostEquals(a.p2c_1, b.p2c_1, epsilon) && isAlmostEquals(a.k2c_1, b.k2c_1, epsilon) && isAlmostEquals(a.l2c_1, b.l2c_1, epsilon) && isAlmostEquals(a.m2c_1, b.m2c_1, epsilon) && isAlmostEquals(a.n2c_1, b.n2c_1, epsilon);
  }
  q2c(l, r) {
    if (l.m29())
      return r;
    if (r.m29())
      return l;
    return new Matrix(l.k2c_1 * r.k2c_1 + l.l2c_1 * r.m2c_1, l.k2c_1 * r.l2c_1 + l.l2c_1 * r.n2c_1, l.m2c_1 * r.k2c_1 + l.n2c_1 * r.m2c_1, l.m2c_1 * r.l2c_1 + l.n2c_1 * r.n2c_1, l.o2c_1 * r.k2c_1 + l.p2c_1 * r.m2c_1 + r.o2c_1, l.o2c_1 * r.l2c_1 + l.p2c_1 * r.n2c_1 + r.p2c_1);
  }
  r2c(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_17().d29_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_17().d29_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_17().d29_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_17().d29_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  s2c(a, b, c, d, tx, ty, p) {
    return Vector2D.d2b(a * p.x28_1 + c * p.y28_1 + tx, d * p.y28_1 + b * p.x28_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_6();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.k2c_1 = a;
    this.l2c_1 = b;
    this.m2c_1 = c;
    this.n2c_1 = d;
    this.o2c_1 = tx;
    this.p2c_1 = ty;
  }
  t2c(other) {
    return Companion_getInstance_6().q2c(this, other);
  }
  m29() {
    return isNaN_0(this.k2c_1);
  }
  n29() {
    return !this.m29();
  }
  u2c() {
    return this.k2c_1 === 1.0 && this.l2c_1 === 0.0 && this.m2c_1 === 0.0 && this.n2c_1 === 1.0 && this.o2c_1 === 0.0 && this.p2c_1 === 0.0;
  }
  v2c() {
    var hasRotation = !(this.l2c_1 === 0.0) || !(this.m2c_1 === 0.0);
    var hasScale = !(this.k2c_1 === 1.0) || !(this.n2c_1 === 1.0);
    var hasTranslation = !(this.o2c_1 === 0.0) || !(this.p2c_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  w2c(p) {
    return this.x2c(p.x28_1, p.y28_1);
  }
  y2c(x, y) {
    return this.x2c(x, y);
  }
  z2c(x, y) {
    return this.a2d(x, y);
  }
  x2c(x, y) {
    return this.k2c_1 * x + this.m2c_1 * y + this.o2c_1;
  }
  a2d(x, y) {
    return this.n2c_1 * y + this.l2c_1 * x + this.p2c_1;
  }
  b2d(x, y) {
    return this.x2c(x, y);
  }
  c2d(x, y) {
    return this.a2d(x, y);
  }
  d2d(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_17().d29_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_17().d29_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.k2c_1 * cos - this.l2c_1 * sin;
    var b = this.k2c_1 * sin + this.l2c_1 * cos;
    var a = a1;
    var c1 = this.m2c_1 * cos - this.n2c_1 * sin;
    var d = this.m2c_1 * sin + this.n2c_1 * cos;
    var c = c1;
    var tx1 = this.o2c_1 * cos - this.p2c_1 * sin;
    var ty = this.o2c_1 * sin + this.p2c_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  e2d(scaleX, scaleY) {
    return this.f2d(scaleX, scaleY);
  }
  f2d(scaleX, scaleY) {
    return new Matrix(this.k2c_1 * scaleX, this.l2c_1 * scaleX, this.m2c_1 * scaleY, this.n2c_1 * scaleY, this.o2c_1 * scaleX, this.p2c_1 * scaleY);
  }
  g2d(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.f2d(scaleX, scaleY) : $super.f2d.call(this, scaleX, scaleY);
  }
  h2d(scaleX, scaleY) {
    return new Matrix(this.k2c_1 * scaleX, this.l2c_1 * scaleX, this.m2c_1 * scaleY, this.n2c_1 * scaleY, this.o2c_1, this.p2c_1);
  }
  i2d(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.h2d(scaleX, scaleY) : $super.h2d.call(this, scaleX, scaleY);
  }
  j2d(delta) {
    return new Matrix(this.k2c_1, this.l2c_1, this.m2c_1, this.n2c_1, this.o2c_1 + delta.x28_1, this.p2c_1 + delta.y28_1);
  }
  k2d(x, y) {
    return this.j2d(Vector2D.q2b(x, y));
  }
  l2d(x, y) {
    return this.j2d(Vector2D.d2b(x, y));
  }
  m2d(delta) {
    return new Matrix(this.k2c_1, this.l2c_1, this.m2c_1, this.n2c_1, this.o2c_1 + (this.k2c_1 * delta.x28_1 + this.m2c_1 * delta.y28_1), this.p2c_1 + (this.l2c_1 * delta.x28_1 + this.n2c_1 * delta.y28_1));
  }
  n2d(deltaX, deltaY) {
    return this.m2d(Vector2D.o2d(deltaX, deltaY));
  }
  p2d(deltaX, deltaY) {
    return this.m2d(Vector2D.d2b(deltaX, deltaY));
  }
  q2d(m) {
    return m.t2c(this);
  }
  r2d() {
    if (this.m29())
      return Companion_getInstance_6().f2c_1;
    var m = this;
    var norm = m.k2c_1 * m.n2c_1 - m.l2c_1 * m.m2c_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.o2c_1, -m.p2c_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.k2c_1 * inorm;
      var a = m.n2c_1 * inorm;
      var b = m.l2c_1 * -inorm;
      var c = m.m2c_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.o2c_1 - c * m.p2c_1, -b * m.o2c_1 - d * m.p2c_1);
    }
    return tmp;
  }
  s2d() {
    return this.t2d();
  }
  t2d() {
    return Companion_getInstance_7().v2d(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.k2c_1) + ', ' + get_niceStr(this.l2c_1) + ', ' + get_niceStr(this.m2c_1) + ', ' + get_niceStr(this.n2c_1) + ', ' + get_niceStr(this.o2c_1) + ', ' + get_niceStr(this.p2c_1) + ')';
  }
  w2d(other, epsilon) {
    return Companion_getInstance_6().j2c(this, other, epsilon);
  }
  hy(other, epsilon) {
    return this.w2d(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  x2d(other) {
    return this.t2c(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.k2c_1);
    result = imul(result, 31) + getNumberHashCode(this.l2c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m2c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n2c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o2c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p2c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.k2c_1, tmp0_other_with_cast.k2c_1))
      return false;
    if (!equals(this.l2c_1, tmp0_other_with_cast.l2c_1))
      return false;
    if (!equals(this.m2c_1, tmp0_other_with_cast.m2c_1))
      return false;
    if (!equals(this.n2c_1, tmp0_other_with_cast.n2c_1))
      return false;
    if (!equals(this.o2c_1, tmp0_other_with_cast.o2c_1))
      return false;
    if (!equals(this.p2c_1, tmp0_other_with_cast.p2c_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.a2e_1 = id;
    this.b2e_1 = hasRotation;
    this.c2e_1 = hasScale;
    this.d2e_1 = hasTranslation;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.u2d_1 = MatrixTransform.l2e(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().o28_1, Companion_getInstance_0().o28_1, Companion_getInstance_0().o28_1);
  }
  m2e(matrix, pivotX, pivotY) {
    var a = matrix.k2c_1;
    var b = matrix.l2c_1;
    var c = matrix.m2c_1;
    var d = matrix.n2c_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians_0(skewY);
      tskewX = get_radians_0(0.0);
      tskewY = get_radians_0(0.0);
    } else {
      trotation = get_radians(0);
      tskewX = get_radians_0(skewX);
      tskewY = get_radians_0(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.o2c_1;
      ty = matrix.p2c_1;
    } else {
      tx = matrix.o2c_1 + (pivotX * a + pivotY * c);
      ty = matrix.p2c_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.l2e(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  v2d(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.m2e(matrix, pivotX, pivotY) : $super.m2e.call(this, matrix, pivotX, pivotY);
  }
  n2e(a, b, epsilon) {
    return isAlmostEquals(a.e2e_1, b.e2e_1, epsilon) && isAlmostEquals(a.f2e_1, b.f2e_1, epsilon) && isAlmostEquals(a.g2e_1, b.g2e_1, epsilon) && isAlmostEquals(a.h2e_1, b.h2e_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.i2e_1, b.i2e_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.j2e_1, b.j2e_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.k2e_1, b.k2e_1, epsilon);
  }
}
class MatrixTransform {
  static l2e(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_7();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().o28_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().o28_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().o28_1 : rotation;
    var $this = createThis(this);
    $this.e2e_1 = x;
    $this.f2e_1 = y;
    $this.g2e_1 = scaleX;
    $this.h2e_1 = scaleY;
    $this.i2e_1 = skewX;
    $this.j2e_1 = skewY;
    $this.k2e_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.e2e_1) + ', y=' + get_niceStr(this.f2e_1) + ', scaleX=' + this.g2e_1 + ', scaleY=' + this.h2e_1 + ', skewX=' + Angle__toString_impl_786qky(this.i2e_1) + ', skewY=' + Angle__toString_impl_786qky(this.j2e_1) + ', rotation=' + Angle__toString_impl_786qky(this.k2e_1) + ')';
  }
  static o2e() {
    Companion_getInstance_7();
    return this.l2e(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().o28_1, Companion_getInstance_0().o28_1, Companion_getInstance_0().o28_1);
  }
  p2e(other, epsilon) {
    return Companion_getInstance_7().n2e(this, other, epsilon);
  }
  hy(other, epsilon) {
    return this.p2e(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  q2e() {
    return (this.g2e_1 + this.h2e_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.e2e_1);
    result = imul(result, 31) + getNumberHashCode(this.f2e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g2e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h2e_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.i2e_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.j2e_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.k2e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.e2e_1, tmp0_other_with_cast.e2e_1))
      return false;
    if (!equals(this.f2e_1, tmp0_other_with_cast.f2e_1))
      return false;
    if (!equals(this.g2e_1, tmp0_other_with_cast.g2e_1))
      return false;
    if (!equals(this.h2e_1, tmp0_other_with_cast.h2e_1))
      return false;
    if (!equals(this.i2e_1, tmp0_other_with_cast.i2e_1))
      return false;
    if (!equals(this.j2e_1, tmp0_other_with_cast.j2e_1))
      return false;
    if (!equals(this.k2e_1, tmp0_other_with_cast.k2e_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.r2e_1 = 0;
    this.s2e_1 = 1;
    this.t2e_1 = 2;
    this.u2e_1 = 3;
    this.v2e_1 = 4;
    this.w2e_1 = 5;
    this.x2e_1 = 6;
    this.y2e_1 = 7;
    this.z2e_1 = 8;
    this.a2f_1 = 9;
    this.b2f_1 = 10;
    this.c2f_1 = 11;
    this.d2f_1 = 12;
    this.e2f_1 = 13;
    this.f2f_1 = 14;
    this.g2f_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.h2f_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.i2f_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.j2f_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.k2f_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.l2f_1 = Matrix4.n2f();
  }
  o2f(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.p2f(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  q2f(l, r) {
    return Companion_getInstance_8().o2f(l.r2f() * r.r2f() + l.s2f() * r.t2f() + l.u2f() * r.v2f() + l.w2f() * r.x2f(), l.r2f() * r.s2f() + l.s2f() * r.y2f() + l.u2f() * r.z2f() + l.w2f() * r.a2g(), l.r2f() * r.u2f() + l.s2f() * r.b2g() + l.u2f() * r.c2g() + l.w2f() * r.d2g(), l.r2f() * r.w2f() + l.s2f() * r.e2g() + l.u2f() * r.f2g() + l.w2f() * r.g2g(), l.t2f() * r.r2f() + l.y2f() * r.t2f() + l.b2g() * r.v2f() + l.e2g() * r.x2f(), l.t2f() * r.s2f() + l.y2f() * r.y2f() + l.b2g() * r.z2f() + l.e2g() * r.a2g(), l.t2f() * r.u2f() + l.y2f() * r.b2g() + l.b2g() * r.c2g() + l.e2g() * r.d2g(), l.t2f() * r.w2f() + l.y2f() * r.e2g() + l.b2g() * r.f2g() + l.e2g() * r.g2g(), l.v2f() * r.r2f() + l.z2f() * r.t2f() + l.c2g() * r.v2f() + l.f2g() * r.x2f(), l.v2f() * r.s2f() + l.z2f() * r.y2f() + l.c2g() * r.z2f() + l.f2g() * r.a2g(), l.v2f() * r.u2f() + l.z2f() * r.b2g() + l.c2g() * r.c2g() + l.f2g() * r.d2g(), l.v2f() * r.w2f() + l.z2f() * r.e2g() + l.c2g() * r.f2g() + l.f2g() * r.g2g(), l.x2f() * r.r2f() + l.a2g() * r.t2f() + l.d2g() * r.v2f() + l.g2g() * r.x2f(), l.x2f() * r.s2f() + l.a2g() * r.y2f() + l.d2g() * r.z2f() + l.g2g() * r.a2g(), l.x2f() * r.u2f() + l.a2g() * r.b2g() + l.d2g() * r.c2g() + l.g2g() * r.d2g(), l.x2f() * r.w2f() + l.a2g() * r.e2g() + l.d2g() * r.f2g() + l.g2g() * r.g2g());
  }
  h2g(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_8().o2f(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  i2g(left, right, bottom, top, near, far) {
    return this.h2g(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static j2g(data) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.m2f_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.m2f_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.a5(toString(message));
    }
    return $this;
  }
  r2f() {
    return this.m2f_1[0];
  }
  t2f() {
    return this.m2f_1[1];
  }
  v2f() {
    return this.m2f_1[2];
  }
  x2f() {
    return this.m2f_1[3];
  }
  s2f() {
    return this.m2f_1[4];
  }
  y2f() {
    return this.m2f_1[5];
  }
  z2f() {
    return this.m2f_1[6];
  }
  a2g() {
    return this.m2f_1[7];
  }
  u2f() {
    return this.m2f_1[8];
  }
  b2g() {
    return this.m2f_1[9];
  }
  c2g() {
    return this.m2f_1[10];
  }
  d2g() {
    return this.m2f_1[11];
  }
  w2f() {
    return this.m2f_1[12];
  }
  e2g() {
    return this.m2f_1[13];
  }
  f2g() {
    return this.m2f_1[14];
  }
  g2g() {
    return this.m2f_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.m2f_1, other.m2f_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.m2f_1);
  }
  k2g(that) {
    return Companion_getInstance_8().q2f(this, that);
  }
  static p2f(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_8();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.j2g(tmp$ret$0);
  }
  static n2f() {
    Companion_getInstance_8();
    return this.p2f(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  f2b(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.a5(toString(message));
    }
    return this.m2f_1[imul(row, 4) + column | 0];
  }
  l2g(index) {
    if (!(0 <= index ? index <= (this.m2f_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.a5(toString(message));
    }
    return this.m2f_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.ub('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.ub('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.ub(', ');
            }
            var v = this.f2b(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.xg(numberToInt(v));
            else {
              this_0.zg(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.ub(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.ub(')');
    return this_0.toString();
  }
}
class Companion_9 {
  constructor() {
    this.v28_1 = 1.0E-7;
  }
  w28(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.x28_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.y28_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.a5(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.r2g_1 = value;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp.s2g_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_0.t2g_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_1.u2g_1 = new RectCorners(numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0));
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    var corner = -1.0;
    tmp_2.v2g_1 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_3.w2g_1 = new RectCorners(numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN));
  }
}
class RectCorners {
  constructor(topLeft, topRight, bottomRight, bottomLeft) {
    Companion_getInstance_10();
    this.x2g_1 = topLeft;
    this.y2g_1 = topRight;
    this.z2g_1 = bottomRight;
    this.a2h_1 = bottomLeft;
  }
  toString() {
    return 'RectCorners(topLeft=' + this.x2g_1 + ', topRight=' + this.y2g_1 + ', bottomRight=' + this.z2g_1 + ', bottomLeft=' + this.a2h_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.x2g_1);
    result = imul(result, 31) + getNumberHashCode(this.y2g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z2g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a2h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCorners))
      return false;
    var tmp0_other_with_cast = other instanceof RectCorners ? other : THROW_CCE();
    if (!equals(this.x2g_1, tmp0_other_with_cast.x2g_1))
      return false;
    if (!equals(this.y2g_1, tmp0_other_with_cast.y2g_1))
      return false;
    if (!equals(this.z2g_1, tmp0_other_with_cast.z2g_1))
      return false;
    if (!equals(this.a2h_1, tmp0_other_with_cast.a2h_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    this.t29_1 = Companion_getInstance_11().b2h(0, 0, 0, 0);
    this.u29_1 = Companion_getInstance_11().c2h(-Infinity, -Infinity, Infinity, Infinity);
    this.v29_1 = Companion_getInstance_11().c2h(NaN, NaN, 0.0, 0.0);
  }
  w29() {
    return this.v29_1;
  }
  i2c() {
    return this.t29_1;
  }
  f2a(p, s) {
    return new Rectangle(p.x28_1, p.y28_1, s.c2a_1, s.d2a_1);
  }
  b2h(x, y, width, height) {
    return Companion_getInstance_11().f2a(Vector2D.q2b(x, y), Size2D.e2a(width, height));
  }
  c2h(x, y, width, height) {
    return Companion_getInstance_11().f2a(Vector2D.o2d(x, y), Size2D.d2h(width, height));
  }
  e2h(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  f2h(left, top, right, bottom) {
    return this.e2h(left, top, right, bottom);
  }
  b2a(point1, point2) {
    var tmp = Companion_getInstance_11();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.d2b(point2.x28_1 - point1.x28_1, point2.y28_1 - point1.y28_1);
    return tmp.f2a(point1, toSize(tmp$ret$0));
  }
  g2h(a, b) {
    return a.h29_1 >= b.h29_1 && a.i29_1 >= b.i29_1 && a.h29_1 + a.j29_1 <= b.h29_1 + b.j29_1 && a.i29_1 + a.k29_1 <= b.i29_1 + b.k29_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_11();
    this.h29_1 = x;
    this.i29_1 = y;
    this.j29_1 = width;
    this.k29_1 = height;
    this.l29_1 = true;
  }
  zy() {
    return this;
  }
  e1() {
    return Size2D.h2h(this.j29_1, this.k29_1);
  }
  i2h() {
    return isNaN_0(this.h29_1);
  }
  m29() {
    return this.i2h();
  }
  n29() {
    return !this.m29();
  }
  j2h(other, epsilon) {
    return isAlmostEquals(this.h29_1, other.h29_1, epsilon) && isAlmostEquals(this.i29_1, other.i29_1, epsilon) && isAlmostEquals(this.j29_1, other.j29_1, epsilon) && isAlmostEquals(this.k29_1, other.k29_1, epsilon);
  }
  hy(other, epsilon) {
    return this.j2h(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.m29() ? 'null' : 'Rectangle(x=' + get_niceStr(this.h29_1) + ', y=' + get_niceStr(this.i29_1) + ', width=' + get_niceStr(this.j29_1) + ', height=' + get_niceStr(this.k29_1) + ')';
  }
  k2h(scale) {
    return new Rectangle(this.h29_1 * scale, this.i29_1 * scale, this.j29_1 * scale, this.k29_1 * scale);
  }
  l2h(that) {
    return this.m2h(that.x28_1, that.y28_1);
  }
  m2h(x, y) {
    return x >= this.o29() && x < this.p29() && (y >= this.q29() && y < this.r29());
  }
  o29() {
    return this.h29_1;
  }
  q29() {
    return this.i29_1;
  }
  p29() {
    return this.h29_1 + this.j29_1;
  }
  r29() {
    return this.i29_1 + this.k29_1;
  }
  g2a() {
    return Vector2D.d2b(this.o29(), this.q29());
  }
  n2h() {
    return Vector2D.d2b(this.p29(), this.q29());
  }
  o2h() {
    return Vector2D.d2b(this.o29(), this.r29());
  }
  i2a() {
    return Vector2D.d2b(this.p29(), this.r29());
  }
  p2h() {
    return (this.p29() + this.o29()) * 0.5;
  }
  q2h() {
    return (this.r29() + this.q29()) * 0.5;
  }
  r2h() {
    return Vector2D.d2b(this.p2h(), this.q2h());
  }
  s2h(that) {
    return this.t2h(that) && this.u2h(that);
  }
  t2h(that) {
    return that.o29() <= this.p29() && that.p29() >= this.o29();
  }
  u2h(that) {
    return that.q29() <= this.r29() && that.r29() >= this.q29();
  }
  v2h(that) {
    var tmp;
    if (this.s2h(that)) {
      // Inline function 'kotlin.math.max' call
      var a = this.o29();
      var b = that.o29();
      var tmp_0 = Math.max(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = this.q29();
      var b_0 = that.q29();
      var tmp_1 = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = this.p29();
      var b_1 = that.p29();
      var tmp_2 = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.min' call
      var a_2 = this.r29();
      var b_2 = that.r29();
      var tmp$ret$3 = Math.min(a_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_11().w29();
    }
    return tmp;
  }
  e2() {
    return RectangleInt.a2i(numberToInt(this.h29_1), numberToInt(this.i29_1), numberToInt(this.j29_1), numberToInt(this.k29_1));
  }
  b2i(border) {
    return Companion_getInstance_11().e2h(this.o29() - border.z2b_1, this.q29() - border.w2b_1, this.p29() + border.x2b_1, this.r29() + border.y2b_1);
  }
  j2d(delta) {
    return this.c2i(this.h29_1 + delta.x28_1, this.i29_1 + delta.y28_1);
  }
  d2i(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.g2a();
      if (m.m29()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.d2b(m.x2c(p.x28_1, p.y28_1), m.a2d(p.x28_1, p.y28_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.n2h();
      if (m.m29()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.d2b(m.x2c(p_0.x28_1, p_0.y28_1), m.a2d(p_0.x28_1, p_0.y28_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.o2h();
      if (m.m29()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.d2b(m.x2c(p_1.x28_1, p_1.y28_1), m.a2d(p_1.x28_1, p_1.y28_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.i2a();
      if (m.m29()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.d2b(m.x2c(p_2.x28_1, p_2.y28_1), m.a2d(p_2.x28_1, p_2.y28_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_17().z29(tl, tr, bl, br);
    var max = Companion_getInstance_17().a2a(tl, tr, bl, br);
    return Companion_getInstance_11().b2a(min, max);
  }
  e2i() {
    return Companion_getInstance_11().b2a(Companion_getInstance_17().h2a(this.g2a(), this.i2a()), Companion_getInstance_17().j2a(this.g2a(), this.i2a()));
  }
  f2i(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  c2i(x, y, width, height, $super) {
    x = x === VOID ? this.h29_1 : x;
    y = y === VOID ? this.i29_1 : y;
    width = width === VOID ? this.j29_1 : width;
    height = height === VOID ? this.k29_1 : height;
    return $super === VOID ? this.f2i(x, y, width, height) : $super.f2i.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.h29_1);
    result = imul(result, 31) + getNumberHashCode(this.i29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k29_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.h29_1, tmp0_other_with_cast.h29_1))
      return false;
    if (!equals(this.i29_1, tmp0_other_with_cast.i29_1))
      return false;
    if (!equals(this.j29_1, tmp0_other_with_cast.j29_1))
      return false;
    if (!equals(this.k29_1, tmp0_other_with_cast.k29_1))
      return false;
    return true;
  }
}
class Companion_12 {
  h2i(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.o29();
    var b_0 = b.o29();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.q29();
    var b_1 = b.q29();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.p29();
    var b_2 = b.p29();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.r29();
    var b_3 = b.r29();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.f2h(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  i2i(topLeft, bottomRight) {
    var size = bottomRight.l2i(topLeft);
    return RectangleInt.a2i(topLeft.j2i_1, topLeft.k2i_1, size.j2i_1, size.k2i_1);
  }
  f2h(left, top, right, bottom) {
    return this.i2i(Vector2I.m2i(left, top), Vector2I.m2i(right, bottom));
  }
}
class RectangleInt {
  static a2i(x, y, width, height) {
    var $this = createThis(this);
    $this.w2h_1 = x;
    $this.x2h_1 = y;
    $this.y2h_1 = width;
    $this.z2h_1 = height;
    return $this;
  }
  static n2i() {
    return this.a2i(0, 0, 0, 0);
  }
  o2i() {
    return imul(this.y2h_1, this.z2h_1);
  }
  o29() {
    return this.w2h_1;
  }
  q29() {
    return this.x2h_1;
  }
  p29() {
    return this.w2h_1 + this.y2h_1 | 0;
  }
  r29() {
    return this.x2h_1 + this.z2h_1 | 0;
  }
  p2i(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.y2h_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.y2h_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.z2h_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.z2h_1);
    return Companion_instance_12.f2h(this.w2h_1 + left_0 | 0, this.x2h_1 + top_0 | 0, this.w2h_1 + right_0 | 0, this.x2h_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.w2h_1 + ', y=' + this.x2h_1 + ', width=' + this.y2h_1 + ', height=' + this.z2h_1 + ')';
  }
  q2i() {
    return Companion_getInstance_11().b2h(this.w2h_1, this.x2h_1, this.y2h_1, this.z2h_1);
  }
  b2i(border) {
    return Companion_instance_12.f2h(this.o29() - border.z2b_1 | 0, this.q29() - border.w2b_1 | 0, this.p29() + border.x2b_1 | 0, this.r29() + border.y2b_1 | 0);
  }
  hashCode() {
    var result = this.w2h_1;
    result = imul(result, 31) + this.x2h_1 | 0;
    result = imul(result, 31) + this.y2h_1 | 0;
    result = imul(result, 31) + this.z2h_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.w2h_1 === tmp0_other_with_cast.w2h_1))
      return false;
    if (!(this.x2h_1 === tmp0_other_with_cast.x2h_1))
      return false;
    if (!(this.y2h_1 === tmp0_other_with_cast.y2h_1))
      return false;
    if (!(this.z2h_1 === tmp0_other_with_cast.z2h_1))
      return false;
    return true;
  }
}
class Companion_13 {}
class RoundRectangle {
  constructor(rect, corners) {
    this.r2i_1 = rect;
    this.s2i_1 = corners;
  }
  toString() {
    return 'RoundRectangle(rect=' + this.r2i_1.toString() + ', corners=' + this.s2i_1.toString() + ')';
  }
  hashCode() {
    var result = this.r2i_1.hashCode();
    result = imul(result, 31) + this.s2i_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RoundRectangle))
      return false;
    var tmp0_other_with_cast = other instanceof RoundRectangle ? other : THROW_CCE();
    if (!this.r2i_1.equals(tmp0_other_with_cast.r2i_1))
      return false;
    if (!this.s2i_1.equals(tmp0_other_with_cast.s2i_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.t2i_1 = Scale.u2i(1.0, 1.0);
  }
}
class Scale {
  static o2g(scaleX, scaleY) {
    Companion_getInstance_14();
    var $this = createThis(this);
    $this.m2g_1 = scaleX;
    $this.n2g_1 = scaleY;
    return $this;
  }
  q2e() {
    return this.m2g_1 * 0.5 + this.n2g_1 * 0.5;
  }
  static v2i() {
    Companion_getInstance_14();
    return this.u2i(1.0, 1.0);
  }
  static w2i(scale) {
    Companion_getInstance_14();
    return this.o2g(scale, scale);
  }
  static x2i(scale) {
    Companion_getInstance_14();
    return this.w2i(scale);
  }
  static u2i(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.o2g(scaleX, scaleY);
  }
  static y2i(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.o2g(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.m2g_1 + ', scaleY=' + this.n2g_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.m2g_1);
    result = imul(result, 31) + getNumberHashCode(this.n2g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.m2g_1, tmp0_other_with_cast.m2g_1))
      return false;
    if (!equals(this.n2g_1, tmp0_other_with_cast.n2g_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp.c2j_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.d2j_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.e2j_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.f2j_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  g2j() {
    return this.e2j_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_15();
    name = name === VOID ? null : name;
    this.h2j_1 = name;
    this.i2j_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.h2j_1 + ')';
  }
  j2j(item, container) {
    return toInt(this.i2j_1(toFloat(item), toFloat(container)));
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.k2j_1 = Size2D.h2h(0.0, 0.0);
  }
}
class Size2D {
  static h2h(width, height) {
    Companion_getInstance_16();
    var $this = createThis(this);
    $this.c2a_1 = width;
    $this.d2a_1 = height;
    return $this;
  }
  static l2j() {
    Companion_getInstance_16();
    return this.h2h(0.0, 0.0);
  }
  static d2h(width, height) {
    Companion_getInstance_16();
    return this.h2h(width, height);
  }
  static e2a(width, height) {
    Companion_getInstance_16();
    return this.h2h(width, height);
  }
  m2j(scale) {
    return Size2D.h2h(this.c2a_1 * scale.m2g_1, this.d2a_1 * scale.n2g_1);
  }
  n2j(s) {
    return Size2D.h2h(this.c2a_1 * s, this.d2a_1 * s);
  }
  k2h(s) {
    return this.n2j(s);
  }
  z2i(other) {
    return Scale.o2g(this.c2a_1 / other.c2a_1, this.d2a_1 / other.d2a_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.c2a_1) + ', height=' + get_niceStr(this.d2a_1) + ')';
  }
  il() {
    return this.c2a_1;
  }
  jl() {
    return this.d2a_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.c2a_1);
    result = imul(result, 31) + getNumberHashCode(this.d2a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.c2a_1, tmp0_other_with_cast.c2a_1))
      return false;
    if (!equals(this.d2a_1, tmp0_other_with_cast.d2a_1))
      return false;
    return true;
  }
}
class SizeInt {
  static q2j(width, height) {
    var $this = createThis(this);
    $this.o2j_1 = width;
    $this.p2j_1 = height;
    return $this;
  }
  static r2j() {
    return this.q2j(0, 0);
  }
  toString() {
    return '' + this.o2j_1 + 'x' + this.p2j_1;
  }
  hashCode() {
    var result = this.o2j_1;
    result = imul(result, 31) + this.p2j_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.o2j_1 === tmp0_other_with_cast.o2j_1))
      return false;
    if (!(this.p2j_1 === tmp0_other_with_cast.p2j_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.z28_1 = Vector2D.d2b(0.0, 0.0);
    this.a29_1 = Vector2D.d2b(NaN, NaN);
    this.b29_1 = Vector2D.d2b(-1.0, 0.0);
    this.c29_1 = Vector2D.d2b(+1.0, 0.0);
    this.d29_1 = Vector2D.d2b(0.0, +1.0);
    this.e29_1 = Vector2D.d2b(0.0, -1.0);
    this.f29_1 = Vector2D.d2b(0.0, -1.0);
    this.g29_1 = Vector2D.d2b(0.0, +1.0);
  }
  s2j(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = a.x28_1;
    var y0 = a.y28_1;
    var x1 = b.x28_1;
    var y1 = b.y28_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  t2j(a, b, up, $super) {
    up = up === VOID ? this.d29_1 : up;
    return $super === VOID ? this.s2j(a, b, up) : $super.s2j.call(this, a, b, up).m28_1;
  }
  u2j(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    // Inline function 'kotlin.math.acos' call
    var x = a.v2j(b) / (a.a() * b.a());
    var radians = Math.acos(x);
    var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
    return adjustFromUp(tmp$ret$1, up);
  }
  w2j(a, b, up, $super) {
    up = up === VOID ? this.d29_1 : up;
    return $super === VOID ? this.u2j(a, b, up) : $super.u2j.call(this, a, b, up).m28_1;
  }
  g2i(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  x2j(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  y2j(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  z2j(a, b) {
    return this.g2i(a.x28_1, a.y28_1, b.x28_1, b.y28_1);
  }
  p2a(a, b) {
    return this.a2k(a.x28_1, a.y28_1, b.x28_1, b.y28_1);
  }
  a2k(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  b2k(ax, ay, bx, by) {
    return ax * by - bx * ay;
  }
  c2k(p1, p2) {
    return this.b2k(p1.x28_1, p1.y28_1, p2.x28_1, p2.y28_1);
  }
  h2a(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.x28_1;
    var b = p2.x28_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.y28_1;
    var b_0 = p2.y28_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.d2b(tmp, tmp$ret$1);
  }
  z29(p1, p2, p3, p4) {
    return Vector2D.d2b(minOf(p1.x28_1, new Float64Array([p2.x28_1, p3.x28_1, p4.x28_1])), minOf(p1.y28_1, new Float64Array([p2.y28_1, p3.y28_1, p4.y28_1])));
  }
  j2a(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.x28_1;
    var b = p2.x28_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.y28_1;
    var b_0 = p2.y28_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.d2b(tmp, tmp$ret$1);
  }
  a2a(p1, p2, p3, p4) {
    return Vector2D.d2b(maxOf(p1.x28_1, new Float64Array([p2.x28_1, p3.x28_1, p4.x28_1])), maxOf(p1.y28_1, new Float64Array([p2.y28_1, p3.y28_1, p4.y28_1])));
  }
}
class Vector2D {
  static d2b(x, y) {
    Companion_getInstance_17();
    var $this = createThis(this);
    $this.x28_1 = x;
    $this.y28_1 = y;
    return $this;
  }
  static o2d(x, y) {
    Companion_getInstance_17();
    return this.d2b(x, y);
  }
  static q2b(x, y) {
    Companion_getInstance_17();
    return this.d2b(x, y);
  }
  static o2b() {
    Companion_getInstance_17();
    return this.d2b(0.0, 0.0);
  }
  b2j() {
    // Inline function 'kotlin.math.min' call
    var a = this.x28_1;
    var b = this.y28_1;
    return Math.min(a, b);
  }
  a2j() {
    // Inline function 'kotlin.math.max' call
    var a = this.x28_1;
    var b = this.y28_1;
    return Math.max(a, b);
  }
  d2k(x, y) {
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this.x28_1;
    var y_0 = y - this.y28_1;
    return hypot(x_0, y_0);
  }
  e2k(that) {
    return this.d2k(that.x28_1, that.y28_1);
  }
  v2j(that) {
    return this.x28_1 * that.x28_1 + this.y28_1 * that.y28_1;
  }
  a() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.x28_1;
    var y = this.y28_1;
    return hypot(x, y);
  }
  f2k() {
    var x = this.x28_1;
    var y = this.y28_1;
    return x * x + y * y;
  }
  g2k() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.x28_1;
    var y = this.y28_1;
    return hypot(x, y);
  }
  h2k() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.g2k();
    return Vector2D.d2b(this.x28_1 * scale, this.y28_1 * scale);
  }
  i2k() {
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    var scale = this.a();
    return Vector2D.d2b(this.x28_1 / scale, this.y28_1 / scale);
  }
  j2k() {
    return Vector2D.d2b(-this.y28_1, this.x28_1);
  }
  k2k(other, epsilon) {
    return isAlmostEquals(this.x28_1, other.x28_1, epsilon) && isAlmostEquals(this.y28_1, other.y28_1, epsilon);
  }
  hy(other, epsilon) {
    return this.k2k(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  l2k() {
    return '(' + get_niceStr(this.x28_1) + ', ' + get_niceStr(this.y28_1) + ')';
  }
  toString() {
    return this.l2k();
  }
  il() {
    return this.x28_1;
  }
  jl() {
    return this.y28_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.x28_1);
    result = imul(result, 31) + getNumberHashCode(this.y28_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.x28_1, tmp0_other_with_cast.x28_1))
      return false;
    if (!equals(this.y28_1, tmp0_other_with_cast.y28_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.m2k_1 = new Vector4F(0.0, 0.0, 0.0, 0.0);
    this.n2k_1 = new Vector4F(1.0, 1.0, 1.0, 1.0);
  }
}
class Vector4F {
  constructor(x, y, z, w) {
    Companion_getInstance_18();
    this.o2k_1 = x;
    this.p2k_1 = y;
    this.q2k_1 = z;
    this.r2k_1 = w;
  }
  toString() {
    return 'Vector4(' + get_niceStr_0(this.o2k_1) + ', ' + get_niceStr_0(this.p2k_1) + ', ' + get_niceStr_0(this.q2k_1) + ', ' + get_niceStr_0(this.r2k_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.o2k_1);
    result = imul(result, 31) + getNumberHashCode(this.p2k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q2k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r2k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector4F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector4F ? other : THROW_CCE();
    if (!equals(this.o2k_1, tmp0_other_with_cast.o2k_1))
      return false;
    if (!equals(this.p2k_1, tmp0_other_with_cast.p2k_1))
      return false;
    if (!equals(this.q2k_1, tmp0_other_with_cast.q2k_1))
      return false;
    if (!equals(this.r2k_1, tmp0_other_with_cast.r2k_1))
      return false;
    return true;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    this.s2k_1 = new Vector3F(NaN, NaN, NaN);
    this.t2k_1 = new Vector3F(0.0, 0.0, 0.0);
    this.u2k_1 = new Vector3F(1.0, 1.0, 1.0);
    this.v2k_1 = new Vector3F(0.0, 0.0, 1.0);
    this.w2k_1 = new Vector3F(0.0, 0.0, -1.0);
    this.x2k_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.y2k_1 = new Vector3F(1.0, 0.0, 0.0);
    this.z2k_1 = new Vector3F(0.0, 1.0, 0.0);
    this.a2l_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_19();
    this.b2l_1 = x;
    this.c2l_1 = y;
    this.d2l_1 = z;
  }
  e2l(other) {
    var dx = this.b2l_1 - other.b2l_1;
    var dy = this.c2l_1 - other.c2l_1;
    var dz = this.d2l_1 - other.d2l_1;
    // Inline function 'kotlin.math.sqrt' call
    var x = dx * dx + dy * dy + dz * dz;
    return Math.sqrt(x);
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.b2l_1) + ', ' + get_niceStr_0(this.c2l_1) + ', ' + get_niceStr_0(this.d2l_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b2l_1);
    result = imul(result, 31) + getNumberHashCode(this.c2l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d2l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.b2l_1, tmp0_other_with_cast.b2l_1))
      return false;
    if (!equals(this.c2l_1, tmp0_other_with_cast.c2l_1))
      return false;
    if (!equals(this.d2l_1, tmp0_other_with_cast.d2l_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    this.f2l_1 = Vector2I.m2i(0, 0);
  }
}
class Vector2I {
  static m2i(x, y) {
    Companion_getInstance_20();
    var $this = createThis(this);
    $this.j2i_1 = x;
    $this.k2i_1 = y;
    return $this;
  }
  static g2l() {
    Companion_getInstance_20();
    return this.m2i(0, 0);
  }
  l2i(that) {
    return Vector2I.m2i(this.j2i_1 - that.j2i_1 | 0, this.k2i_1 - that.k2i_1 | 0);
  }
  toString() {
    return '(' + this.j2i_1 + ', ' + this.k2i_1 + ')';
  }
  hashCode() {
    var result = this.j2i_1;
    result = imul(result, 31) + this.k2i_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.j2i_1 === tmp0_other_with_cast.j2i_1))
      return false;
    if (!(this.k2i_1 === tmp0_other_with_cast.k2i_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_0();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_0();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2_0($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__umod_impl_4wilf7($this, angle) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(angle);
  return _Angle___init__impl__g23q1m(umod(tmp, tmp$ret$1));
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.m28_1, other instanceof Angle ? other.m28_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_0();
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.m28_1, other instanceof Angle ? other.m28_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.m28_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngleDenormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, false);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_9.w28(up);
  return up.y28_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_17().d29_1 : up;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  Companion_getInstance_0();
  var x = y1 - y0;
  var y = x1 - x0;
  var up_0 = Companion_getInstance_17().d29_1;
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  // Inline function 'kotlin.math.atan2' call
  var radians = Math.atan2(x, y);
  var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$1, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().o28_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().s28_1) : angle, up);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$0);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_0().q28_1) <= 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_0 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_0().s28_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_1 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_0().s28_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).m29();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).n29();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).o29();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).p29();
  return Math.min(a, b);
}
function _BoundsBuilder___get_xmax__impl__gsz0km($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).o29();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).p29();
  return Math.max(a, b);
}
function _BoundsBuilder___get_ymin__impl__5n2e8j($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).q29();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).r29();
  return Math.min(a, b);
}
function _BoundsBuilder___get_ymax__impl__oia4uz($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).q29();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).r29();
  return Math.max(a, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).m29())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().f2a(p, Size2D.e2a(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().b2a(Companion_getInstance_17().h2a(_BoundsBuilder___get_bounds__impl__s1l1gx($this).g2a(), p), Companion_getInstance_17().j2a(_BoundsBuilder___get_bounds__impl__s1l1gx($this).i2a(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.m29())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.g2a()), rect.i2a());
}
function BoundsBuilder__plus_impl_cz7f7x_1($this, p) {
  var bb = $this;
  var inductionVariable = 0;
  var last = p.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, p.d1(n));
    }
     while (inductionVariable < last);
  return bb;
}
function BoundsBuilder__plus_impl_cz7f7x_2($this, rects) {
  var bb = $this;
  var _iterator__ex2g4s = rects.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it);
  }
  return bb;
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.k2a_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_8().i2g(rect.o29(), rect.p29(), rect.r29(), rect.q29(), near, far);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.f2d(scale.m2g_1, scale.n2g_1);
}
function get_scale(_this__u8e3s4) {
  return Scale.o2g(_this__u8e3s4.g2e_1, _this__u8e3s4.h2e_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_10;
function Companion_getInstance_10() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.p2h();
  var centerY = _this__u8e3s4.q2h();
  return new Circle(_this__u8e3s4.r2h(), Companion_getInstance_17().g2i(centerX, centerY, _this__u8e3s4.p29(), _this__u8e3s4.q29()));
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.d2b(_this__u8e3s4.m2g_1, _this__u8e3s4.n2g_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.k2h(toVector2(c.z2i(i)).a2j());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.k2h(toVector2(c.z2i(i)).b2j());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function toFloat(_this__u8e3s4) {
  return Size2D.d2h(_this__u8e3s4.o2j_1, _this__u8e3s4.p2j_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.q2j(numberToInt(_this__u8e3s4.c2a_1), numberToInt(_this__u8e3s4.d2a_1));
}
function toSize(_this__u8e3s4) {
  return Size2D.h2h(_this__u8e3s4.x28_1, _this__u8e3s4.y28_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.m29()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.d2b(m.x2c(_this__u8e3s4.x28_1, _this__u8e3s4.y28_1), m.a2d(_this__u8e3s4.x28_1, _this__u8e3s4.y28_1));
  }
  return tmp$ret$0.x28_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.m29()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.d2b(m.x2c(_this__u8e3s4.x28_1, _this__u8e3s4.y28_1), m.a2d(_this__u8e3s4.x28_1, _this__u8e3s4.y28_1));
  }
  return tmp$ret$0.y28_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.m2i(numberToInt(_this__u8e3s4.x28_1), numberToInt(_this__u8e3s4.y28_1));
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.d2b(interpolate_0(_this__u8e3s4, l.x28_1, r.x28_1), interpolate_0(_this__u8e3s4, l.y28_1, r.y28_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).iy = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.n2b);
initMetadataForCompanion(Companion_5);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_6);
protoOf(Matrix).iy = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_7);
protoOf(MatrixTransform).iy = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.n2f);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_10);
initMetadataForClass(RectCorners, 'RectCorners');
initMetadataForCompanion(Companion_11);
protoOf(Rectangle).iy = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.n2i);
initMetadataForCompanion(Companion_13);
initMetadataForClass(RoundRectangle, 'RoundRectangle');
initMetadataForCompanion(Companion_14);
initMetadataForClass(Scale, 'Scale', Scale.v2i);
initMetadataForCompanion(Companion_15);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_16);
initMetadataForClass(Size2D, 'Size2D', Size2D.l2j);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.r2j);
initMetadataForCompanion(Companion_17);
protoOf(Vector2D).iy = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.o2b, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(Vector4F, 'Vector4F');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_20);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.g2l);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_9 = new Companion_9();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
//endregion
//region block: exports
export {
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstance26n3n49ggvwm4,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m36yxttgnpy5tv,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds24obl4qqhxk1t,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq,
  Angle__cosine_impl_bgvzun as Angle__cosine_impl_bgvzun1b2925dagclby,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw2n539uvc01e1n,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd1qmy7ftoy1opp,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btd19ndx9mxcgcss,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndtx0rhatnvuhb1,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7ko02ca30grn4a,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys1q15xt9x23bx,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37karx983dsduoy,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt518seywpfbf9fr,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on435dv91f5cbp85,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi39oh4tio4auz1,
  Angle__sine_impl_3l11xv as Angle__sine_impl_3l11xv3pgl8zzgp52i0,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg,
  Angle__times_impl_v3s9y2_0 as Angle__times_impl_v3s9y21yznxo5bj1uj7,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y220yjbrxc13c3b,
  Angle__umod_impl_4wilf7 as Angle__umod_impl_4wilf71vq5gai237g1r,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fruk5m76f5kg06,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3,
  BoundsBuilder__plus_impl_cz7f7x_2 as BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y,
  BoundsBuilder__plus_impl_cz7f7x_1 as BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p,
  _BoundsBuilder___get_xmax__impl__gsz0km as _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa,
  _BoundsBuilder___get_xmin__impl__o2sib0 as _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri,
  _BoundsBuilder___get_ymax__impl__oia4uz as _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r,
  _BoundsBuilder___get_ymin__impl__5n2e8j as _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5,
  Companion_getInstance as Companion_getInstanceeqp3ibr2vvu9,
  Companion_getInstance_0 as Companion_getInstance3rze5babd97ff,
  Companion_getInstance_1 as Companion_getInstance2yu48324co92b,
  Companion_getInstance_5 as Companion_getInstancenbeyvbsm21qs,
  Companion_getInstance_6 as Companion_getInstance1zxby1ngivg0d,
  Companion_getInstance_8 as Companion_getInstance3qti4zygy7usz,
  Companion_getInstance_10 as Companion_getInstance3lu3946d91kk8,
  Companion_getInstance_11 as Companion_getInstance1bdwtq6rroayu,
  Companion_instance_12 as Companion_instanceu31qrc8c1r0r,
  Companion_getInstance_15 as Companion_getInstance23o88a0u6ly94,
  Companion_getInstance_16 as Companion_getInstance1j5nd3fbu9uao,
  Companion_getInstance_17 as Companion_getInstancewdpvtc2ehxkt,
  Companion_getInstance_19 as Companion_getInstance1yq7a1f60lp2k,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  isNotEmpty as isNotEmptyrwyeygz7izwg,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectCorners as RectCorners2yrtl8r42p5bs,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  RoundRectangle as RoundRectangle271svjyf7w51p,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2I as Vector2I2k5512l4eeahb,
  Vector4F as Vector4F1clr35ctch8js,
  adjustFromUp as adjustFromUp1ak85cceintt4,
  get_degrees as get_degrees3czcd4ojw4i,
  interpolateAngleDenormalized as interpolateAngleDenormalized1hkwzk523mo1c,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  get_radians as get_radians391vbqqjsolq6,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_1 as interpolatewhd2sgxffql5,
};
//endregion
